<template>
  <div class="explainer-container">
    <div class="container-m flex-center-middle flex-column padding-xl-bottom">
      <h2
        id="title"
        v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
        class="animate--delay-300 hide padding-l-top padding-2xl-bottom">
        {{ t("justopp.howDoesItWork.title") }}
      </h2>
      <div class="steps flex-wrap flex-center-middle">
        <div
          v-for="(step, index) in steps"
          :key="step.title"
          v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
          class="step flex-column flex-center-middle text-center hide"
          :class="`animate--delay-${index * 100 + 200}`">
          <div
            v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
            class="circle bg-alt relative radius-round">
            <icon size="3.25" :icon="step.icon" />
            <span class="step-number absolute">{{ index + 1 }}</span>
          </div>
          <h4 class="padding-l-top">{{ t(step.title) }}</h4>
          <p class="step-description">{{ t(step.description) }}</p>
        </div>
      </div>
      <saffron-link
        v-if="!isLoggedIn"
        v-slot="{ navigate }"
        class="plain-link"
        :to="{ name: 'user-register' }">
        <form-button
          v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
          class="get-started margin-2xl-top animate--delay-400 gap-l flex-center flex-middle hide"
          theme="lead"
          text="justopp.howDoesItWork.buttonCta"
          @click="navigate"
          >{{ t("justopp.howDoesItWork.buttonCta") }}
        </form-button>
      </saffron-link>
    </div>
  </div>
  <div class="spacer">
    <icon icon="explainer-bottom" />
  </div>
</template>

<script>
export default {
  name: "HowDoesItWork",
  components: {},
  setup() {
    const steps = [
      {
        icon: "create-profile",
        title: "justopp.howDoesItWork.stepTitle.createProfile",
        description: "justopp.howDoesItWork.createProfile",
      },
      {
        icon: "search-deal",
        title: "justopp.howDoesItWork.stepTitle.searchDeal",
        description: "justopp.howDoesItWork.searchDeal",
      },
      {
        icon: "purchase-method",
        title: "justopp.howDoesItWork.stepTitle.purchaseMethod",
        description: "justopp.howDoesItWork.purchaseMethod",
      },
      {
        icon: "make-deal",
        title: "justopp.howDoesItWork.stepTitle.makeADeal",
        description: "justopp.howDoesItWork.makeADeal",
      },
    ];

    return { steps };
  },
};
</script>

<style lang="scss" scoped>
#title {
  text-align: center;

  @media (min-width: 1024px) {
    padding-top: var(--margin-max) !important;
  }
}

.circle {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 1024px) {
    width: 122px;
    height: 122px;

    i {
      width: 65px !important;
      height: 65px !important;
      flex: 1 !important;
    }
  }
}

.step {
  max-width: 280px;

  @media (min-width: 1024px) {
    max-width: 380px;
  }

  .step-description {
    line-height: 1.5;
  }

  .step-number {
    left: 0;
    top: 0;
    font-weight: 600;
    font-size: var(--font-max);
    transform: translateY(-25%);

    @media (min-width: 1024px) {
      font-size: 60px;
      transform: translateY(-40%);
    }
  }
}

.get-started {
  width: 200px;
  font-size: var(--font-xl) !important;
  z-index: 10;

  @media (min-width: 1024px) {
    width: 220px;
    transform: translateY(120%);
  }
}

.spacer {
  width: 100%;
  height: 50px;
  background-color: var(--c-light-gray-2);

  @media (min-width: 1024px) {
    height: 200px;
  }

  i {
    width: 100% !important;
    height: 100% !important;
    background-color: var(--c-bg) !important;
  }
}
.hide {
  opacity: 0;
}

.explainer-container {
  background-color: var(--c-light-gray-2);
}

.steps {
  row-gap: var(--margin-max);
  column-gap: calc(var(--margin-max) * 2);
  @media (min-width: 1024px) {
    row-gap: calc(var(--margin-max) * 1.5);
  }
}
</style>
